export default "__VITE_ASSET__1bdc9899__"